export const overviewBundle = {
  tabs: [
    { id: "today", label: { ko: "오늘", en: "Today", es: "Hoy" }, value: 1 },
    { id: "7days", label: { ko: "7일", en: "7days", es: "7 dias" }, value: 7 },
    { id: "30days", label: { ko: "30일", en: "30days", es: "30 dias" }, value: 30 }
  ]
}
